import { Link, useLocation } from 'react-router-dom'
import { LayoutDashboard, Wrench, Car, Menu } from 'lucide-react'
import { cn } from '../../lib/utils'
import { useState } from 'react'
import { MoreSheet } from './MoreSheet'

const tabs = [
  { name: 'Home', icon: LayoutDashboard, href: '/dashboard' },
  { name: 'Jobs', icon: Wrench, href: '/jobs' },
  { name: 'History', icon: Car, href: '/vehicles' },
]

export function BottomTabBar() {
  const location = useLocation()
  const [moreOpen, setMoreOpen] = useState(false)

  const isActive = (href: string) =>
    href === '/dashboard' ? location.pathname === '/dashboard' : location.pathname.startsWith(href)

  return (
    <>
      <nav className="fixed bottom-0 inset-x-0 z-sticky border-t border-border bg-surface-primary/95 backdrop-blur-xl md:hidden">
        <div
          className="flex items-center justify-around"
          style={{
            height: 'calc(var(--bottom-bar-height) + var(--safe-area-bottom))',
            paddingBottom: 'var(--safe-area-bottom)',
          }}
        >
          {tabs.map((tab) => {
            const active = isActive(tab.href)
            return (
              <Link
                key={tab.name}
                to={tab.href}
                className={cn(
                  'flex flex-col items-center justify-center gap-0.5 min-w-[48px] min-h-[44px] px-2 transition-colors',
                  active ? 'text-primary-300' : 'text-content-tertiary'
                )}
              >
                <tab.icon className="h-5 w-5" strokeWidth={active ? 2.5 : 2} />
                <span className={cn('text-[10px]', active ? 'font-bold' : 'font-medium')}>
                  {tab.name}
                </span>
              </Link>
            )
          })}
          <button
            onClick={() => setMoreOpen(true)}
            className="flex flex-col items-center justify-center gap-0.5 min-w-[48px] min-h-[44px] px-2 text-content-tertiary transition-colors hover:text-content-primary"
          >
            <Menu className="h-5 w-5" />
            <span className="text-[10px] font-medium">More</span>
          </button>
        </div>
      </nav>
      <MoreSheet open={moreOpen} onOpenChange={setMoreOpen} />
    </>
  )
}
